/* ==========================================================================
   IRON FIT — Complete Packages overlay
   Circle-wipe overlay from the "Wana save?" button.

   The card is a poster and a price, nothing more. It shows the WHOLE poster
   — uncropped, so the machine, the bench, the bar and the plates are all
   visible — and its button opens the package's own page (bundle.html?b=…),
   where the kit is itemised with photos and the extra plates and dumbbells
   are picked. The packages themselves live in ifz-bundles.js.

   The phone's pinned bar (ifz-sections.js) still buys in one tap; every card
   exposes card.ifzAdd() for it, so the quick buy does not depend on a button
   being present in the card.
   ========================================================================== */
(function () {
  'use strict';

  var ALL = window.IFZ_BUNDLES || [];

  /* ======================================================================
     THE RACK

     Families of packages — the crossover gym in four plate weights, the
     Smith gym in three — collapse to a single card that opens the chooser.
     What counts as a family is defined once, in ifz-tiers.js.
     ====================================================================== */
  function groups() { return T ? T.groups() : []; }
  function groupFor(id) { return T ? T.groupFor(id) : null; }
  function groupByKey(k) { return T ? T.groupByKey(k) : null; }

  var PACKAGES = [];
  (function () {
    var done = {};
    ALL.forEach(function (b) {
      var g = groupFor(b.id);
      if (!g) { PACKAGES.push(b); return; }
      if (done[g.key]) return;
      done[g.key] = 1;
      var lo = Math.min.apply(null, g.tiers.map(function (t) { return t.price; }));
      PACKAGES.push({
        id: g.key + '-group',
        group: true,
        groupKey: g.key,
        machine: b.machine,
        name: g.name,
        badge: g.badge,
        solid: true,
        best: g.tiers.some(function (t) { return t.best; }),
        img: b.img,
        img2x: b.img2x,
        price: lo,
        was: null,
        tagline: g.tiers.length + ' plate options — ' +
                 g.tiers.map(function (t) { return t.plateKg; }).join(', ') + ' kg.'
      });
    });
  })();

  function money(n) { return window.IFZCart.money(n); }


  /* The chooser lives in ifz-tiers.js, because the machine pages need it too
     and they share no other code with this file. This one just opens it. */
  var T = window.IFZTiers;
  function openTiers(key) { if (T) T.open(key); }

  function buildCard(p) {
    var card = document.createElement('article');
    /* pkc--group is how the pinned phone bar knows this card has nothing
       to add yet — see pinnedBar() in ifz-sections.js. */
    card.className = 'pkc' + (p.best ? ' pkc--best' : '') + (p.group ? ' pkc--group' : '');

    /* ---- media ----
       The poster is shown WHOLE. It is a tall print that already has the whole
       kit standing together, the price, and the delivery + installation line
       on it — cropping it to a letterbox threw the pitch away and left only
       the top of the rack. */
    var media = document.createElement('div');
    media.className = 'pkc__media';
    var badge = document.createElement('span');
    badge.className = 'pkc__badge' + (p.solid ? '' : ' pkc__badge--ghost');
    badge.textContent = p.badge;
    /* The full-size master, not a downscale of it: a card paints ~300 css px,
       which a 3× phone renders at ~900 real pixels. The 760px file it used to
       load was being stretched on every modern phone. WebP where the browser
       takes it, the same JPEG where it doesn't. */
    var pic = window.IFZPic(p.img, p.name + ' — everything included');
    media.appendChild(badge);
    media.appendChild(pic);

    /* ---- body ----
       No contents list any more: the poster shows the kit, and the package
       page itemises it with a photo of every single piece. */
    var body = document.createElement('div');
    body.className = 'pkc__body';

    var h = document.createElement('h3');
    h.className = 'pkc__name';
    h.textContent = p.name;

    var price = document.createElement('div');
    price.className = 'pkc__price';
    var b = document.createElement('b');
    /* "From" on the group card. It stands for four boxes at four prices, and
       a bare $899 beside it reads as the price of the thing you are looking
       at rather than the cheapest of what is behind it. */
    b.textContent = (p.group ? 'From ' : '') + money(p.price);
    price.appendChild(b);
    if (p.was) {
      var s = document.createElement('s');
      s.textContent = money(p.was);
      var save = document.createElement('span');
      save.className = 'pkc__save';
      save.textContent = 'Save ' + money(p.was - p.price);
      price.appendChild(s);
      price.appendChild(save);
    }

    var note = document.createElement('p');
    note.className = 'pkc__note';
    note.textContent = 'Delivery + professional installation included';

    /* primary action: open the package and look inside it.

       The group card is the exception — it has no page of its own, because
       it is not a package. It opens the chooser instead. */
    var see = document.createElement(p.group ? 'button' : 'a');
    see.className = 'pkc__see';
    if (p.group) {
      see.type = 'button';
      see.innerHTML = '<span>Choose your plates</span><i aria-hidden="true">→</i>';
      see.addEventListener('click', function (e) { e.preventDefault(); openTiers(p.groupKey); });
    } else {
      see.href = p.href;
      see.innerHTML = '<span>See everything inside</span><i aria-hidden="true">→</i>';
    }

    /* Desktop keeps a one-tap buy, because desktop has no pinned bar. On
       phones the bar pinned to the bottom of the overlay is that button, so
       this one is hidden by CSS rather than stacked underneath it. */
    var cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'pkc__cta pkc__cta--quick';
    cta.innerHTML = '<span>🛒</span><span>Add to cart</span>';

    /* Nothing to add: which of the four has not been chosen yet. The whole
       card opens the chooser instead, so a tap anywhere on it does the
       obvious thing rather than only the small button at the bottom. */
    if (p.group) {
      cta.classList.add('pkc__cta--choose');
      var g0 = groupByKey(p.groupKey);
      cta.innerHTML = '<span>' + g0.tiers.length + ' options</span><span>' +
                      g0.tiers.map(function (t) { return t.plateKg; }).join(' · ') + ' KG</span>';
      cta.addEventListener('click', function () { openTiers(p.groupKey); });
      media.style.cursor = 'pointer';
      media.addEventListener('click', function () { openTiers(p.groupKey); });
    }

    var added = false;

    /* The pinned phone bar buys through this, so adding to the cart never
       depends on a button being visible — or even present — in the card. */
    card.ifzAdd = function () {
      if (added) { window.location.href = window.IFZU('cart-revamp.html'); return; }
      window.IFZCart.add({
        type: 'package',
        name: p.name,
        price: p.price,
        img: p.img2x || p.img,
        key: p.cod || ('pkg-' + p.id),
        extras: [],
        includes: p.includes
      });
      added = true;
      card.classList.add('is-added');
      cta.classList.add('is-added');
      cta.innerHTML = '<span>✓</span><span>Added! View cart →</span>';
    };

    /* AFTER the default, not before it.

       The group card is a chooser: nothing can go in the cart until a plate
       weight has been picked, so its ifzAdd opens the four options instead.
       Written above the default it was simply overwritten, and the pinned
       phone bar — which buys through ifzAdd — quietly added the 20 kg box
       while the button said "Choose your plates". */
    if (p.group) {
      card.ifzAdd = function () { openTiers(p.groupKey); };
    }

    cta.addEventListener('click', card.ifzAdd);

    body.appendChild(h);
    body.appendChild(price);
    body.appendChild(note);
    body.appendChild(see);
    body.appendChild(cta);

    card.appendChild(media);
    card.appendChild(body);
    return card;
  }

  /* ==========================================================================
     3D "door" carousel
     The grid element is turned into a 3D track: every card is absolutely
     stacked on the same spot and pushed into place by its slot offset from
     the front card (…, -2, -1, 0, +1, +2, …). Slot 0 faces the viewer flat;
     the others are hinged away like open doors. Slots wrap, so the strip is
     endless. Hovering bends the front card toward the pointer and swings the
     hovered side door open toward you.
     ========================================================================== */
  function initCarousel(grid) {
    var cards = [].slice.call(grid.children);
    var n = cards.length;
    if (!n) return null;

    /* ---------- chrome: [wing] ← [ stage ] → [wing] + dots ---------- */
    var wrap = document.createElement('div');
    wrap.className = 'pkcar';
    grid.parentNode.insertBefore(wrap, grid);

    var row = document.createElement('div');
    row.className = 'pkcar__row';
    wrap.appendChild(row);

    function el(tag, cls) { var e = document.createElement(tag); e.className = cls; return e; }
    function navBtn(side, glyph, label) {
      var b = el('button', 'pkcar__nav pkcar__nav--' + side);
      b.type = 'button';
      b.setAttribute('aria-label', label);
      b.textContent = glyph;
      return b;
    }

    var stage = el('div', 'pkcar__stage');
    var prev = navBtn('prev', '←', 'Previous package');
    var next = navBtn('next', '→', 'Next package');

    row.appendChild(el('div', 'pkcar__edge pkcar__edge--l'));
    row.appendChild(prev);
    row.appendChild(stage);
    row.appendChild(next);
    row.appendChild(el('div', 'pkcar__edge pkcar__edge--r'));

    grid.classList.add('pkcar__track');
    stage.appendChild(grid);

    var dots = el('div', 'pkcar__dots');
    var dotEls = cards.map(function (card, i) {
      var d = el('button', 'pkcar__dot');
      d.type = 'button';
      var nm = card.querySelector('.pkc__name');
      d.setAttribute('aria-label', nm ? nm.textContent : 'Package ' + (i + 1));
      d.addEventListener('click', function () { go(i); });
      dots.appendChild(d);
      return d;
    });
    wrap.appendChild(dots);

    /* ---------- state ---------- */
    var index = 0;
    var slots = [];                 /* last slot per card, to catch wrap jumps */
    var px = 0, py = 0;             /* pointer, -1 … 1 across the stage */
    var hovering = false;
    var hoverIdx = -1;              /* side card the pointer is resting on */
    var raf = 0;
    var soft = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function metrics() {
      var w = stage.clientWidth || 1;
      if (w < 560) return { rot: 34, x: 54, z: 130, vis: 1, bend: 0 };
      if (w < 900) return { rot: 43, x: 59, z: 175, vis: 2, bend: 6 };
      return { rot: 52, x: 63, z: 210, vis: 2, bend: 9 };
    }
    var m = metrics();

    function layout() {
      cards.forEach(function (card, i) {
        var s = i - index;
        if (s > n / 2) s -= n;             /* wrap: the strip has no ends */
        else if (s < -n / 2) s += n;
        var a = Math.abs(s);
        var sign = s < 0 ? -1 : 1;
        var jumped = slots[i] !== undefined && Math.abs(slots[i] - s) > 1;
        slots[i] = s;

        var t, o, zi;
        if (a === 0) {
          /* front card bends toward the pointer: the side you hover leans in */
          var by = hovering ? m.bend * px : 0;
          var bx = hovering ? -m.bend * .5 * py : 0;
          t = 'translate3d(0,0,30px) rotateY(' + by.toFixed(2) + 'deg) rotateX(' + bx.toFixed(2) + 'deg)';
          o = 1;
          zi = 30;
        } else if (a <= m.vis) {
          var open = hoverIdx === i ? 1 : 0;   /* hovered door swings open */
          var x = sign * (m.x + m.x * .72 * (a - 1));
          var z = -(m.z * a + 55 * (a - 1)) + open * 95;
          var ry = -sign * (m.rot - open * 18);
          var sc = 1 - .06 * a;
          t = 'translateX(' + x + '%) translateZ(' + z + 'px) rotateY(' + ry + 'deg) scale(' + sc + ')';
          o = Math.min(1, (a === 1 ? .98 : .66) + open * .25);
          zi = 20 - a;
        } else {
          t = 'translateX(' + (sign * 118) + '%) translateZ(-640px) rotateY(' + (-sign * 62) + 'deg) scale(.72)';
          o = 0;
          zi = 0;
        }

        /* a card that wrapped from one end to the other teleports instead of
           flying across the front — hide the jump, then fade it back in */
        if (jumped) {
          card.style.transition = 'none';
          card.style.opacity = '0';
          card.style.transform = t;
          void card.offsetWidth;
          card.style.transition = '';
        }

        card.style.transform = t;
        card.style.opacity = String(o);
        card.style.zIndex = String(zi);
        card.classList.toggle('is-front', a === 0);
        card.classList.toggle('is-near', a === 1);
        card.setAttribute('aria-hidden', a === 0 ? 'false' : 'true');
      });

      /* whole rack drifts a touch with the pointer */
      grid.style.transform = hovering && !soft ? 'rotateY(' + (-px * 2.2).toFixed(2) + 'deg)' : '';
    }

    function measure() {
      var h = cards[index].offsetHeight;
      if (h) grid.style.height = h + 'px';
    }

    function queue() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; layout(); });
    }

    function go(i) {
      index = ((i % n) + n) % n;
      hoverIdx = -1;
      dotEls.forEach(function (d, k) {
        d.classList.toggle('is-on', k === index);
        d.setAttribute('aria-current', k === index ? 'true' : 'false');
      });
      layout();
      measure();
    }

    /* ---------- arrows, dots, keys ---------- */
    prev.addEventListener('click', function () { go(index - 1); });
    next.addEventListener('click', function () { go(index + 1); });

    /* ---------- pointer sensitivity ---------- */
    stage.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch' || soft) return;
      var r = stage.getBoundingClientRect();
      px = ((e.clientX - r.left) / r.width - .5) * 2;
      py = ((e.clientY - r.top) / r.height - .5) * 2;
      hovering = true;
      wrap.classList.toggle('is-hot-l', px < -.6);
      wrap.classList.toggle('is-hot-r', px > .6);
      var front = cards[index];
      front.style.setProperty('--mx', ((px + 1) * 50).toFixed(1) + '%');
      front.style.setProperty('--my', ((py + 1) * 50).toFixed(1) + '%');
      queue();
    });

    stage.addEventListener('pointerleave', function () {
      hovering = false;
      hoverIdx = -1;
      px = py = 0;
      wrap.classList.remove('is-hot-l');
      wrap.classList.remove('is-hot-r');
      queue();
    });

    cards.forEach(function (card, i) {
      card.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch' || soft) return;
        if (i !== index) { hoverIdx = i; queue(); }
      });
      card.addEventListener('pointerleave', function () {
        if (hoverIdx === i) { hoverIdx = -1; queue(); }
      });
      /* capture, so a click on a door can never reach its button or its link */
      card.addEventListener('click', function (e) {
        if (i !== index) { e.preventDefault(); e.stopPropagation(); go(i); }
      }, true);
      /* tabbing into a door brings it to the front */
      card.addEventListener('focusin', function () { if (i !== index) go(i); });
    });

    /* ---------- drag / swipe ---------- */
    var downX = null, dragged = false;
    stage.addEventListener('pointerdown', function (e) {
      if (e.button) return;
      downX = e.clientX;
      dragged = false;
    });
    stage.addEventListener('pointermove', function (e) {
      if (downX !== null && Math.abs(e.clientX - downX) > 12) dragged = true;
    });
    window.addEventListener('pointerup', function (e) {
      if (downX === null) return;
      var dx = e.clientX - downX;
      downX = null;
      if (Math.abs(dx) > 55) go(index + (dx < 0 ? 1 : -1));
    });
    stage.addEventListener('click', function (e) {
      if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; }
    }, true);

    /* ---------- keep the track as tall as the front card ---------- */
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { measure(); });
      cards.forEach(function (c) { ro.observe(c); });
    }
    window.addEventListener('resize', function () { m = metrics(); layout(); measure(); });

    go(0);
    return {
      go: go,
      next: function () { go(index + 1); },
      prev: function () { go(index - 1); },
      refresh: function () { m = metrics(); layout(); measure(); }
    };
  }

  function init() {
    var btn = document.getElementById('saveme');
    var pk = document.getElementById('pk');
    if (!btn || !pk) return;

    /* The pill quotes the biggest saving on the rack. Derived, not typed —
       a number hard-coded in the markup goes stale the first time a package
       price moves, and this one is a promise. */
    var saveEl = btn.querySelector('[data-pk-save]');
    if (saveEl && window.IFZ_BUNDLES) {
      var best = 0;
      window.IFZ_BUNDLES.forEach(function (b) {
        if (b.was && b.was > b.price) best = Math.max(best, b.was - b.price);
      });
      if (best > 0) saveEl.textContent = '— save up to $' + best;
    }

    var grid = pk.querySelector('.pk__grid');
    var car = null;

    /* The rack is built the first time somebody asks for it.

       It used to be built on page load, and because the overlay is laid out
       (just clipped away) the browser dutifully fetched all five posters —
       385 KB spent before anyone had tapped anything, on the one screen that
       decides whether a visitor stays. */
    function build() {
      if (car) return;
      PACKAGES.forEach(function (p) { grid.appendChild(buildCard(p)); });
      var bestIdx = 0;
      PACKAGES.forEach(function (p, i) { if (p.best) bestIdx = i; });
      car = initCarousel(grid);
      if (car) car.go(bestIdx);        /* open on the best-value package */

      /* the phone's pinned bar waits for this rather than polling blindly */
      document.dispatchEvent(new CustomEvent('ifz:packages-ready'));
    }

    var closeBtn = pk.querySelector('.pk__close');

    /* Leaving the rack entirely is as deliberate as pressing the X on the
       chooser, so it clears the trail too. */
    function dropTrail() { if (T) T.close(); }

    function origin() {
      var r = btn.getBoundingClientRect();
      return (r.left + r.width / 2).toFixed(0) + 'px ' + (r.top + r.height / 2).toFixed(0) + 'px';
    }

    var lastOrigin = '50% 44%';
    var hideTimer = null;

    function open() {
      build();
      clearTimeout(hideTimer);
      lastOrigin = origin();
      pk.style.clipPath = 'circle(0px at ' + lastOrigin + ')';
      pk.classList.add('is-vis');
      document.documentElement.classList.add('pk-open');
      void pk.offsetWidth;
      pk.classList.add('is-open');
      pk.style.clipPath = 'circle(150% at ' + lastOrigin + ')';
      pk.scrollTop = 0;
      if (car) car.refresh();     /* sizes are only real once the overlay is up */
      try { closeBtn.focus({ preventScroll: true }); } catch (e) {}

      /* Came back from a tier's own page: put the chooser straight back up.
         The visitor was part-way through picking a plate weight and the back
         arrow is supposed to return them to that, not to the rack. */
      var back = T ? T.wanted() : '';
      if (back) openTiers(back);
    }

    function close() {
      dropTrail();
      pk.style.clipPath = 'circle(0px at ' + lastOrigin + ')';
      pk.classList.remove('is-open');
      document.documentElement.classList.remove('pk-open');
      hideTimer = setTimeout(function () { pk.classList.remove('is-vis'); }, 750);
      try { btn.focus({ preventScroll: true }); } catch (e) {}
    }

    btn.addEventListener('click', open);
    closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (!pk.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (!car) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); car.next(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); car.prev(); }
    });

    /* Any control anywhere that points at #packages opens the overlay —
       the header CTA, the floating pill's own handler, an in-page link.
       Bound by href rather than by class so a reworked header cannot
       quietly lose it, which is what happened when "Packages" stopped
       being a .nav__link. #build is the old name, kept so an existing
       bookmark or a stale link still lands somewhere sensible. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href="#packages"], a[href="#build"]') : null;
      if (!a) return;
      e.preventDefault();
      open();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
